export default async (url, seekTo = 0.0, callback) => {
    try {
        const videoPreview = document.createElement('video');
        videoPreview.setAttribute('src', url);
        videoPreview.setAttribute('crossorigin', 'anonymous');
        videoPreview.load();
        await videoPreview.addEventListener('error', (ex) => {
            return Error("error when loading video file", ex);
        });

        await videoPreview.addEventListener('loadedmetadata', () => {
            if (videoPreview.duration < seekTo) {
                return Error("video is too short.");
            }
            // delay seeking or else 'seeked' event won't fire on Safari
            setTimeout(() => {
                videoPreview.currentTime = seekTo;
            }, 200);
            videoPreview.addEventListener('seeked', () => {
                const canvas = document.createElement("canvas");
                canvas.width = videoPreview.videoWidth;
                canvas.height = videoPreview.videoHeight;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(videoPreview, 0, 0, canvas.width, canvas.height);
                ctx.canvas.toBlob(
                    blob => {
                        if (callback) {
                            callback(URL.createObjectURL(blob))
                        } else {
                            return URL.createObjectURL(blob);
                        }
                    },
                    "image/jpeg",
                    1 /* quality */
                );
            });
        });
    } catch (error) {
        console.log(error);
        return Error(error);
    }
}